
import styles from './storyContent.module.css';

const StoryContent = () => (
  <div className={styles.app__story_container}>
    <div className={styles.app__story_wrapper}>
      <div className={styles.app__story_title}>
        <span>BIBS UP, PHONES DOWN. IT&apos;S #SHAKINGTIME</span>
      </div>
      <div className={styles.app__story_text}>
        {/* eslint-disable-next-line max-len */}
        <p>Shaking Crab began as a lunch craving for fresh New England shellfish and bold Cajun flavors in the  spring of 2015.  Kevin and Nick, co-workers in a downtown Boston office, frequently lunched together in a quest to fulfill a mutual love of spicy and fragrant foods.
        </p>
        {/* eslint-disable-next-line max-len */}
        <p>One day, Nick returned from a trip to California and excitedly described his favorite meal of the trip: a crab boil with shrimp, crab legs and crawfish, all drenched in a rich, garlicky, and spicy sauce.  Kevin, raised in California, immediately recognized the crab boils that his friends and family would have for summer cook-outs and the routine outings at boil restaurants.  Unfortunately, crab boils were not an option in Boston at the time despite the high quality and adoration of New England shellfish.
        </p>
        {/* eslint-disable-next-line max-len */}
        <p>&quot;Let&apos;s open one, then we can eat it whenever we want!&quot;</p>
        {/* eslint-disable-next-line max-len */}
        <p>It started as a joke, but the craving was real and the pair began experimenting with the sauce, testing different amounts of garlic, types of butter, and of course, the ratio of the Cajun spice mix.  So when Nick passed by a small restaurant in Newton, MA that was up for sale on his commute to work, the pair had no choice but to dive in, head first.
        </p>
        {/* eslint-disable-next-line max-len */}
        <p>On December 18, 2015, Shaking Crab Newton opened it&apos;s doors to the public and the joke became a dream and reality.
        </p>
        {/* eslint-disable-next-line max-len */}
        <p>Our goal is to spread the love of buttery, garlicky, spicy shellfish throughout New England and beyond.
        </p>
      </div>
      <div className={styles.app__story_title}>
        <span>COME SHAKE WITH US, AND YOU&apos;LL SEE WHY.</span>
      </div>
    </div>
  </div>
);

export default StoryContent;
